export const COMPLETED_TRANSACTION_STATUSES = [
  'completed',
  'ready',
  'voided',
  'refunded',
  'partially_refunded'
];
